import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { LastOrder } from '@/lib/types/order.types.ts';
import type { CartItem } from '@/lib/types/cart.types.ts';

interface InitialState {
	lastOrder: LastOrder | null;
	selectedService: Partial<CartItem> | null;
}

interface Store extends InitialState {
	setLastOrder: (lastOrder: LastOrder | null) => void;
	setSelectedService: (service: Partial<CartItem> | null) => void;
}

const initialState: InitialState = {
	lastOrder: null,
	selectedService: null,
};

const orderStore = create<Store>()(
	persist(
		(set) => {
			const setLastOrder = (lastOrder: LastOrder | null) => {
				set({ lastOrder });
			};

			const setSelectedService = (service: Partial<CartItem> | null) => {
				set({ selectedService: service });
			};

			return {
				...initialState,

				setLastOrder,
				setSelectedService,
			};
		},
		{
			name: 'order',
			partialize: (state) => ({ lastOrder: state.lastOrder }),
		},
	),
);

export default orderStore;
